export function getBasicInterpretation({ accuracy = 0, averageReactionTime = 0 }) {
  if (accuracy >= 85) {
    return {
      level: "high",
      title: "Rendimiento adecuado-alto",
      text: "La precisión ha sido alta durante la tarea. Puede indicar buena comprensión de la consigna y adecuado mantenimiento atencional.",
    };
  }

  if (accuracy >= 70) {
    return {
      level: "adequate",
      title: "Rendimiento adecuado con aspectos a observar",
      text: "La ejecución general ha sido funcional, aunque conviene observar los errores y el estilo de respuesta.",
    };
  }

  if (accuracy >= 50) {
    return {
      level: "observe",
      title: "Dificultad moderada",
      text: "Se observan errores frecuentes. Puede ser útil repetir la tarea en otro momento y valorar si aparecen dificultades atencionales, impulsividad o fatiga.",
    };
  }

  return {
    level: "difficulty",
    title: "Dificultad elevada",
    text: "La precisión ha sido baja en esta ejecución. Se recomienda interpretarlo junto con la observación clínica y otros datos de evaluación.",
  };
}